import { useSelector } from 'react-redux';
import { visibleFor } from '../utlis/restrictedModules';

export const usePermissions = (resource) => {
  const permissions = useSelector((state) => state.permission.myPermissions);
  const isLoading = useSelector((state) => state.permission.myPermissionsLoading);

  const perm = permissions.find((p) => p.resource === resource) || {};

  return {
    canCreate: perm.can_create ?? false,
    // For a handful of modules (Employee/Department/Role/Company/Location/Security
    // Questions), can_read being granted on the role isn't enough to see the module
    // itself — see restrictedModules.js.
    canRead:   visibleFor(resource, perm.can_read ?? false),
    canUpdate: perm.can_update ?? false,
    canDelete: perm.can_delete ?? false,
    canImport: perm.can_import ?? false,
    canExport: perm.can_export ?? false,
    isLoading,
  };
};